(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['underscore'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var _ = require('underscore');
    module.exports = factory(_);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (_) {
  'use strict';

  /**
   * Utility methods for views.
   *
   * @class viewUtils
   * @static
   */
  return {
    /**
     * This method will update the className property of the view and regenerate the el of the view.
     * This is only safe to use during initialize (before the el is used) after that use with caution (it may have
     * unintended side effects).
     *
     * @method updateViewClassNameDuringInitialize
     * @param view {Backbone.View} the backbone view to update the className on.
     * @param className {String} the new className to use for the view.
     */
    updateViewClassNameDuringInitialize: function(view, className) {
      delete view.el;
      delete view.$el;
      view.className = className;
      view._ensureElement();
    },

    /**
     * This method will re-apply the view attributes and pick up any changes.
     *
     * @method updateViewElAttributes
     * @param view {Backbone.View} the backbone view to extend the attributes on.
     */
    updateViewElAttributes: function(view) {
      var attrs = _.extend({}, _.result(view, 'attributes'));
      view._setAttributes(attrs);
    }
  };
}));
